import {
    SWITCH_COLLASPED, SWITCH_CURRENT_MENU, SET_ADMIN, REMOVE_ADMIN
} from "../mutation-types";

import fetch from '@/common/js/http';

const sysAdmin = {
    namespaced: true,
    state: {
        drawer: false,
        token: '',
        adminInfo: null,
        collapsed: false,
        menu: '',
        snackbar: {
            show: false,
            type: '',
            text: ''
        }
    },
    mutations: {
        [SWITCH_COLLASPED](state) {
            state.collapsed = !state.collapsed
        },
        [SWITCH_CURRENT_MENU](state, menu) {
            state.menu = menu
        },
        [SET_ADMIN](state, {adminInfo, token}) {
            state.adminInfo = adminInfo
            state.token = token

            localStorage.setItem('user-info', JSON.stringify(adminInfo))
            localStorage.setItem('token', token)
        },
        [REMOVE_ADMIN](state) {
            state.adminInfo = null
            state.token = ''
                
            localStorage.clear();
        },
        ['SET_SNACKBAR'](state, option) {
            state.snackbar = option
        },
        SET_DRAWER(state, value) {
            state.drawer = value
        }
    },
    actions: {
        switchCollasped({commit}) {
            return commit(SWITCH_COLLASPED)
        },
        activeMenu({commit}, menu) {
            return commit(SWITCH_CURRENT_MENU, menu)
        },
        adminLogin({commit}, request) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'adminLogin',
                    method: 'post',
                    data: request
                }).then(success => {
                    resolve(success)
                    commit(SET_ADMIN, {adminInfo: success.data.data, token: success.data.token})
                }, error => {
                    reject(error)
                })
            })
        },
        adminLogout({commit}) {
            return new Promise((resolve, reject) => {
                return fetch({
                    url: 'adminLogout',
                    method: 'post',
                }).then(success => {
                    resolve(success)
                    commit(REMOVE_ADMIN)
                }, error => {
                    reject(error)
                })
            })
        }
    }
}

export default sysAdmin



// WEBPACK FOOTER //
// ./src/vuex/modules/sysAdmin.js